import { EntityType } from '@crew/enums/domain'
import { useTranslation } from '@crew/modules/dist/i18n'
import { ValidateRules } from '@crew/utils/dist/form'
import { useMemberDataSource } from 'hooks/dataSource/useMemberDataSource'
import { useTaskPriorityDataSource } from 'hooks/dataSource/useResourceDataSource'
import { useTaskKindDataSource } from 'hooks/dataSource/useTaskKindDataSource'
import { useForm } from 'react-hook-form'

// フォームの型定義
// タスクテンプレートタスク
export type FormValues = {
  subject: string
  taskKindId: string
  taskPriority: number
  assignToUserId: string | null
  requiredDays: number | null
  description: string
}

const initialValues: FormValues = {
  subject: '',
  taskKindId: '',
  taskPriority: 3,
  assignToUserId: null,
  requiredDays: null,
  description: '',
}

export const useTaskTemplateTaskListAndEntryForm = (projectId: string) => {
  const {
    clearErrors,
    control,
    formState,
    handleSubmit,
    trigger,
    reset,
    getValues,
    setValue,
  } = useForm<FormValues>({
    mode: 'onChange',
    criteriaMode: 'all',
    defaultValues: initialValues,
  })

  const { t } = useTranslation()

  const taskKindDataSource = useTaskKindDataSource(
    EntityType.Project,
    projectId,
    false, // hasBaseFilter
    false, // グループ化を行うか
    false // multiSelect
  )

  const taskPriorityDataSource = useTaskPriorityDataSource()

  const memberDataSource = useMemberDataSource(
    EntityType.Project,
    projectId,
    undefined,
    false
  )

  const validateRules: ValidateRules<FormValues> = {
    subject: {
      required: t('message.general.isRequired', {
        name: t('label.taskSubject'),
      }),
    },
    taskKindId: {
      required: t('message.general.isRequired', {
        name: t('label.taskKind'),
      }),
    },
    taskPriority: {
      required: t('message.general.isRequired', {
        name: t('label.taskPriority'),
      }),
    },
    assignToUserId: {},
    requiredDays: {},
    description: {},
  }

  return {
    control,
    handleSubmit,
    trigger,
    reset,
    getValues,
    setValue,
    clearErrors,
    formState,
    taskKindDataSource,
    taskPriorityDataSource,
    memberDataSource,
    validateRules,
  }
}
